/*
 * @Author: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @Date: 2025-10-30 20:50:29
 * @LastEditors: CN\yangtianyu01 yangtianyu01@corp.netease.com
 * @LastEditTime: 2025-11-11 10:14:13
 * @FilePath: \mpc-monorepo\apps\mpc-external\src\containers\SmWorkbench\ProjectDetail\Show\Detail\FirstAskDetail\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react';
import RequirementContent from '@mpc/common/src/features/MPCDemand/KOLInquiryForQuotation/RequirementContent';
import DesignatedExpert from '@mpc/common/src/features/MPCDemand/KOLInquiryForQuotation/DesignatedExpert';
import SFormItem from '@mpc/common/src/components/SForm/SFormItem';
import CustomInspection from '@mpc/common/src/features/CustomInspection';
// import useMPCDemand from '@/model/MPCDemand';
import KOLTable from '@mpc/common/src/features/MPCDemand/KOLInquiryForQuotation/KOLTable';

interface Props {
  detail: any;
  className?: string;
  proCardProps?: any;
}

const FirstAskDetail = ({ detail, className, proCardProps }: Props) => {
  // const { setIsQuoteTableFullscreen } = useMPCDemand();
  if (detail?.plan_type !== 2) {
    return null;
  }

  return <div className={className}>
    <RequirementContent view tabsModel l3_category_id={detail?.l3_category_id} detail={detail} proCardProps={proCardProps} />
    <SFormItem
      noStyle
      formItemKey={['demand_source_detail_vo', 'demand_source_kol_vo']}
      watchChildFormValidate={true}
      validateTrigger={false}
      render={() => (
        <DesignatedExpert
          className="m-t-24"
          showFullScreen
          // handleFullChange={setIsQuoteTableFullscreen}
          type="supplierDetail"
          view
          l3_category_id={detail?.l3_category_id}
          proCardProps={proCardProps}
        />
      )}
    />
    <CustomInspection className="m-t-24" name={['demand_source_detail_vo','demand_source_custom_inspection_vo']} view tabsModel proCardProps={proCardProps} />
  </div>;
};

export default FirstAskDetail;
